module.exports = __webpack_public_path__ + "img/right-arm_active.2a42245e.png";